import { getCurrentUrl } from 'common/utils/getUrl';

export function getScormUrl(scormId: string) {
    // Build the scorm url with current url as next
    const baseUrl = import.meta.env.VITE_BASE_URL || '';
    const nextUrl = getCurrentUrl();

    return `${baseUrl}/scorm/${scormId}?next=${nextUrl}`;
}
